export default __webpack_public_path__ + "static/media/oe_2.a61036d0.mp3";